import { ApolloClient, InMemoryCache } from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
import { config } from '../config';

const token = JSON.parse(window.localStorage.getItem('token'));
const pathIds = window.location.pathname.split('/');

const setupApolloClient = async () => {
  const params = new URL(document.location).searchParams;
  const orgId = params.get('organization') || pathIds[1];
  const secret = await fetch(`${config.lnt_api_url}/hasura-token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      orgId: orgId,
      token: token,
    }),
  })
    .then((res) => res.json())
    .then((json) => {
      return json;
    })
    .catch((err) => {
      console.log('Error in ApolloClient.js, calling /v1/hasura-token');
      console.log(err);
    });

  const wsLink = new WebSocketLink({
    uri: `wss://${config.db_url}`,
    options: {
      reconnect: true,
      connectionParams: {
        headers: {
          'x-hasura-admin-secret': secret,
        },
      },
    },
  });

  return new ApolloClient({
    link: wsLink,
    cache: new InMemoryCache(),
  });
};

export const client = setupApolloClient();
